import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-paste-from-word',
  templateUrl: './modal-paste-from-word.component.html',
  styleUrls: ['./modal-paste-from-word.component.scss']
})
export class ModalPasteFromWordComponent implements OnInit, AfterViewInit {

  @ViewChild('okBtn', { static: true }) okBtn: any;
  @Input() editor: any;
  @Input() content: string = '';

  formGroup: FormGroup;
  submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      content: [this.content, [Validators.required]],
    });
  }

  submit() {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return;
    }

    this.submitted = false;

    const formData: any = this.formGroup.value;
    this.editor.insertText(formData.content);
    this.activeModal.close();
  }

  ngAfterViewInit(): void {
    this.okBtn.nativeElement.focus();
  }

}
